{
  "INTEGRATION_APPS": {
    "FETCHING": "Henter Integrationer",
    "NO_HOOK_CONFIGURED": "Der er ingen {integrationId} integrationer konfigureret på denne konto.",
    "HEADER": "Applikationer",
    "COUNT": "{n} integration | {n} integrations",
    "SEARCH_PLACEHOLDER": "Search...",
    "NO_RESULTS": "No results found matching your search",
    "STATUS": {
      "ENABLED": "Aktiveret",
      "DISABLED": "Deaktiveret"
    },
    "CONFIGURE": "Konfigurer",
    "ADD_BUTTON": "Tilføj en ny krog",
    "DELETE": {
      "TITLE": {
        "INBOX": "Bekræft sletning",
        "ACCOUNT": "Afbryd"
      },
      "MESSAGE": {
        "INBOX": "Er du sikker på du vil slette?",
        "ACCOUNT": "Er du sikker på at du afbryder?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Ja, Slet",
        "ACCOUNT": "Ja, Afbryd"
      },
      "CANCEL_BUTTON_TEXT": "Annuller",
      "API": {
        "SUCCESS_MESSAGE": "Hook slettet",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
      }
    },
    "LIST": {
      "FETCHING": "Henter integrationshoks",
      "INBOX": "Indbakke",
      "ACTIONS": "Handlinger",
      "DELETE": {
        "BUTTON_TEXT": "Slet"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Vælg Indbakke",
          "PLACEHOLDER": "Vælg Indbakke"
        },
        "SUBMIT": "Opret",
        "VALIDATING_OPENAI": "Validating with OpenAI...",
        "CANCEL": "Annuller"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integration hook tilføjet",
        "ERROR_MESSAGE": "Kunne ikke oprette forbindelse til Woot Server, Prøv igen senere"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Tilslut"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Afbryd"
    },
    "SIDEBAR_DESCRIPTION": {
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details"
    }
  }
}
